import { render, staticRenderFns } from "./ServiceAnalyticsSubjectTutorLoadLeaderboard.vue?vue&type=template&id=dfcd0e06&"
import script from "./ServiceAnalyticsSubjectTutorLoadLeaderboard.vue?vue&type=script&setup=true&lang=js&"
export * from "./ServiceAnalyticsSubjectTutorLoadLeaderboard.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports